import moment from 'moment';
import queryString from 'query-string';
import { GraphDateRange } from '../store/diagnostics/types';

export const SAVINGS_FILTER_OPTIONS = [
  { value: '7Days', label: 'Past 7 Days', startDatetime: '', endDatetime: '' },
  { value: '30Days', label: 'Past 30 Days', startDatetime: '', endDatetime: '' },
  { value: 'month', label: 'Past Month', startDatetime: '', endDatetime: '' },
  { value: '3Months', label: 'Past 3 Months', startDatetime: '', endDatetime: '' },
  { value: 'year', label: 'Past Year', startDatetime: '', endDatetime: '' },
  { value: 'custom', label: 'Select Range', startDatetime: '', endDatetime: '' },
];

export const FILTER_OPTIONS = [
  { value: '1Hour', label: 'Past Hour', startDatetime: '', endDatetime: '' },
  { value: '6Hours', label: 'Past 6 Hours', startDatetime: '', endDatetime: '' },
  { value: '24Hours', label: 'Past 24 Hours', startDatetime: '', endDatetime: '' },
  { value: '48Hours', label: 'Past 48 Hours', startDatetime: '', endDatetime: '' },
  { value: '7Days', label: 'Past 7 Days', startDatetime: '', endDatetime: '' },
  { value: '30Days', label: 'Past 30 Days', startDatetime: '', endDatetime: '' },
  { value: '3Months', label: 'Past 3 Months', startDatetime: '', endDatetime: '' },
  { value: 'custom', label: 'Select Range', startDatetime: '', endDatetime: '' },
];

export function addSearchParams(graphDateRange: GraphDateRange, customDataPoints: string[] = []) {
  const { value, startDatetime = '', endDatetime = '' } = graphDateRange;
  let search = '';

  search = `${search}filter=${value}`;
  if (value === 'custom') {
    search = `${search}&from=${moment(startDatetime).unix()}`;
    search = `${search}&to=${moment(endDatetime).unix()}`;
  }
  if (customDataPoints.length > 0) {
    search = `${search}&data_points=${customDataPoints.join(',')}`;
  }

  return search;
}

export function addThermostatSearchParams(graphDateRange: GraphDateRange, uid = '', points: string[] = []) {
  const { value, startDatetime = '', endDatetime = '' } = graphDateRange;

  let search = '';
  if (uid !== '') {
    search = `uid=${uid}&`;
  }
  search = `${search}filter=${value}`;
  if (value === 'custom') {
    search = `${search}&from=${moment(startDatetime).unix()}`;
    search = `${search}&to=${moment(endDatetime).unix()}`;
  }

  if (points.length > 0) {
    search = `${search}&points=${points.join(',')}`;
  }
  return search;
}

export const getFilter = (filter: string) => FILTER_OPTIONS.find((option) => option.value === filter);

export const getSavingsFilter = (filter: string) => SAVINGS_FILTER_OPTIONS.find((option) => option.value === filter);

export function getFilterFromUrlParams(search: string) {
  const params = queryString.parse(search);

  let filter = getFilter(params.filter as string);
  if (filter) {
    if (filter.value === 'custom') {
      const startDatetime = moment
        .unix(params.from as any)
        .utc()
        .format();
      const endDatetime = moment
        .unix(params.to as any)
        .utc()
        .format();
      filter = {
        ...filter,
        startDatetime,
        endDatetime,
      };
    }
  }
  return filter || { value: '30Days', label: 'Past 30 Days' };
}

export function getSavingsFilterFromUrlParams(search: string) {
  const params = queryString.parse(search);

  let filter = getSavingsFilter(params.filter as string);
  if (filter) {
    if (filter.value === 'custom') {
      const startDatetime = moment
        .unix(params.from as any)
        .utc()
        .format();
      const endDatetime = moment
        .unix(params.to as any)
        .utc()
        .format();
      filter = {
        ...filter,
        startDatetime,
        endDatetime,
      };
    }
  }

  return filter || { value: '30Days', label: 'Past 30 Days' };
}

export function getDiagnosticsFilterFromUrlParams(search: string) {
  const params = queryString.parse(search);

  let filter = getFilter(params.filter as string);
  if (filter) {
    if (filter.value === 'custom') {
      const startDatetime = moment
        .unix(params.from as any)
        .utc()
        .format();
      const endDatetime = moment
        .unix(params.to as any)
        .utc()
        .format();
      filter = {
        ...filter,
        startDatetime,
        endDatetime,
      };
    }
  }
  return filter;
}

export function getThermostatsFilterFromUrlParams(search: string) {
  const params = queryString.parse(search);

  let filter = getFilter(params.filter as string);
  if (filter) {
    if (filter.value === 'custom') {
      const startDatetime = moment
        .unix(params.from as any)
        .utc()
        .format();
      const endDatetime = moment
        .unix(params.to as any)
        .utc()
        .format();
      filter = {
        ...filter,
        startDatetime,
        endDatetime,
      };
    }
  }
  return filter;
}

export function getDataPointsFromUrlParams(search: string) {
  const params = queryString.parse(search);
  let { data_points = [] } = params;

  if (!data_points || !params) {
    data_points = [];
    return data_points;
  }

  if (data_points.length) {
    data_points = (data_points as string).split(',');
  }

  return data_points;
}

export function getThermostatFromUrlParams(search: string) {
  const params = queryString.parse(search);

  const { uid = '' } = params;
  return uid;
}

export function getEditAlertFromUrlParams(search: string) {
  const params = queryString.parse(search);
  const { id = '' } = params;
  return id;
}
